import type { ReactNode } from "react";
import { Typo } from "@pepperstone/pepper-ui-kit";

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <Typo elem="h1" type="heading" size="xxl">
      {children}
    </Typo>
  );
}
